import { useState, useEffect } from 'react';
import '../App.css';

function Number(props) {

    const [data, setData] = useState(props.data)
    const [resultValue, setResultValue] = useState(null)

    function addValue(pos) {

        var currentNumber = data;

        if (currentNumber.values.find(e => e.position === pos) !== undefined) {
            currentNumber.values.forEach(element => {
                if (element.position === pos) {
                    element.value = element.value + props.betValue
                }
            });
        } else {
            currentNumber.values.push({
                position: pos,
                value: props.betValue,
                number: data.number
            })
        }

        var orig = props.numbers;



        var result = [];

        orig.forEach(element => {

            if (element.number === data.number) {
                element = currentNumber;
            }

            result.push(element)
        });

        props.setNumbers(result)
    }

    const center = data.values.find(e => e.position === 'center')
    const right = data.values.find(e => e.position === 'right')
    const top = data.values.find(e => e.position === 'top')
    const four = data.values.find(e => e.position === 'four')

    const selectColorCenter = center !== undefined ? center.value > 99 ? 'active-color--violet' : center.value > 49 ? 'active-color--orange' : center.value > 24 ? 'active-color--blue' : center.value > 9 ? 'active-color--green' : center.value > 4 ? 'active-color--pink' : center.value > 1 ? 'active-color--light-violet' : '' : ''
    const selectColorHorizontal = right !== undefined ? right.value > 99 ? 'active-color--violet' : right.value > 49 ? 'active-color--orange' : right.value > 24 ? 'active-color--blue' : right.value > 9 ? 'active-color--green' : right.value > 4 ? 'active-color--pink' : right.value > 1 ? 'active-color--light-violet' : '' : ''
    const selectColorVertical = top !== undefined ? top.value > 99 ? 'active-color--violet' : top.value > 49 ? 'active-color--orange' : top.value > 24 ? 'active-color--blue' : top.value > 9 ? 'active-color--green' : top.value > 4 ? 'active-color--pink' : top.value > 1 ? 'active-color--light-violet' : '' : ''
    const selectColorFour = four !== undefined ? four.value > 99 ? 'active-color--violet' : four.value > 49 ? 'active-color--orange' : four.value > 24 ? 'active-color--blue' : four.value > 9 ? 'active-color--green' : four.value > 4 ? 'active-color--pink' : four.value > 1 ? 'active-color--light-violet' : '' : ''

    var red = [32, 19, 21, 25, 34, 27, 36, 30, 23, 5, 16, 1, 14, 9, 18, 7, 12, 3];

    function hightLight4Numbers(start) {
        var result = [...props.numbers];
        result[start - 1].hover = true
        result[start].hover = true
        result[start + 2].hover = true
        result[start + 3].hover = true
        props.setNumbers(result)
    }

    function hightLight2NumbersHorizontally(start) {
        var result = [...props.numbers];
        result[start - 1].hover = true
        result[start - 4].hover = true
        props.setNumbers(result)
    }

    function hightLight2NumbersVertically(start) {
        var result = [...props.numbers];
        result[start - 1].hover = true
        result[start].hover = true
        props.setNumbers(result)
    }


    function add2HorizontalValues(pos) {
        var currentNumber = data;
        if (currentNumber.values.find(e => e.position === pos) !== undefined) {
            currentNumber.values.forEach(element => {
                if (element.position === pos) {
                    element.value = element.value + props.betValue
                }
            });
        } else {
            currentNumber.values.push({
                position: pos,
                value: props.betValue
            })
        }

        var orig = props.numbers;

        var rightValue = orig[currentNumber.number];

        if (rightValue.values.find(e => e.position === 'side') !== undefined) {
            rightValue.values.forEach(element => {
                if (element.position === 'side') {
                    element.value = element.value + props.betValue
                }
            });
        } else {
            rightValue.values.push({
                position: 'side',
                value: props.betValue,

            })
        }

        var result = [];

        orig.forEach(element => {

            if (element.number === data.number) {
                element = currentNumber;
            }

            result.push(element)
        });

        props.setNumbers(result)
    }

    function add2VerticalValues(pos) {

        var currentNumber = props.numbers[data.number - 1];

        if (currentNumber.values.find(e => e.position === pos) !== undefined) {
            currentNumber.values.forEach(element => {
                if (element.position === pos) {
                    element.value = element.value + props.betValue
                }
            });
        } else {
            currentNumber.values.push({
                position: pos,
                value: props.betValue
            })
        }

        var orig = props.numbers;

        var bottomValue = orig[data.number - 4];

        if (bottomValue.values.find(e => e.position === 'side') !== undefined) {
            bottomValue.values.forEach(element => {
                if (element.position === 'side') {
                    element.value = element.value + props.betValue
                }
            });
        } else {
            bottomValue.values.push({
                position: 'side',
                value: props.betValue,

            })
        }

        var result = [];

        orig.forEach(element => {

            if (element.number === data.number) {
                element = currentNumber;
            }

            result.push(element)
        });

        props.setNumbers(result)
    }


    function add4Values(pos) {

        var currentNumber = data.number;
        var number2 = data.number + 1
        var number3 = data.number + 3
        var number4 = data.number + 4

        var orig = [...props.numbers]

        var result = []

        orig.forEach(element => {
            if (element.number === currentNumber) {
                if (element.values.find(e => e.position === pos) !== undefined) {
                    element.values.forEach(el => {
                        if (el.position === pos) {
                            el.value = el.value + props.betValue
                        }
                    });
                } else {
                    element.values.push({
                        position: pos,
                        value: props.betValue,
                        number: currentNumber
                    })
                }
            }
            result.push(element)
        });

        var numbersArray = [number2, number3, number4];

        numbersArray.forEach(number => {
            orig.forEach(element => {
                if (element.number === number) {
                    element.values.push({
                        position: 'side',
                        value: props.betValue,
                        type: '4values',
                        number: element.number
                    })
                }
            });
        });

        props.setNumbers(result)

    }


    useEffect(() => {

        var finalCount = 0;
        var sideValue = 0

        if (data.values.find(e => e.calculated) !== undefined) {

            data.values.forEach(element => {
                if (element.position === 'side') {
                    if (sideValue === 0) {
                        sideValue = element.calculated
                    }
                } else if (element.position === 'side_1_18') {
                    return false
                } else if (element.position === 'side_1_12') {
                    return false
                } else if (element.position === 'center') {
                    if (element.number == props.winnerValue) {
                        finalCount = finalCount + element.value * 35;
                    } else {
                        finalCount = finalCount - element.value;
                    }
                } else if (element.position === 'red') {
                    return false
                }
                else {
                    finalCount = finalCount + element.calculated;
                }
            })

            data.values.forEach(element => {
                if (element.position === 'side') {
                    if (props.winnerValue != data.number) {
                        sideValue = 0 - element.value
                    }
                } else if (element.position === 'top') {

                    if (props.winnerValue != data.number) {
                        finalCount = 0 - element.value
                    }
                } else if (element.position === 'four') {

                    if (props.winnerValue != data.number) {
                        finalCount = 0 - element.value
                    }
                } else if (element.position === 'right') {

                    if (props.winnerValue != data.number) {
                        finalCount = 0 - element.value
                    }
                }
            })

            finalCount = finalCount + sideValue;
        }

        if (finalCount === 0) {
            setResultValue(0)
        } else {
            if (finalCount < 0) {
                setResultValue(finalCount)
            } else {
                setResultValue("+" + finalCount)
            }
        }


    }, [props.numbers, data.values, data.values[0]])

    useEffect(() => {
        if (resultValue === '+NaN') {
            setResultValue('+0')
        }
        if (data.values.length !== 0) {
            if (data.number !== props.winnerValue && data.values[0].position === 'side') {
                //setResultValue(0)
            } else if (data.number === props.winnerValue && data.values[0].position === 'side') {
                setResultValue(0)
            }

        }

    }, [resultValue])


    return (
        <div data-num={data.number} class="oval-number border-2 border-white border-solid" className={(data.hover === true) ? 'greenHighlight' : (red.indexOf(data.number) !== -1) ? 'red' : 'bet-black'}>
            <div class="td-three"></div>
            {
                (data.number < 37 && data.number > 3)
                    ? <div className={`zero-line ${(top !== undefined && resultValue === 0) ? 'active-cursor' : ''} ${selectColorVertical}`}
                        data-value={(data.values.find(e => e.position === 'top') !== undefined) ? data.values.find(e => e.position === 'top').value : null}
                        onMouseEnter={e => hightLight2NumbersHorizontally(data.number)}
                        onMouseLeave={e => props.cancelHighlight()}
                        onClick={props.wheelSpin === false ? e => add2VerticalValues('top') : null}
                    ></div>
                    : ''
            }

            <div class="td-bottom"></div>
            {
                (data.number !== 36 && data.number !== 33 && data.number !== 35 && data.number !== 34)
                    ? <div className={`four-value ${(four !== undefined && resultValue === 0) ? 'active-cursor' : ''} ${selectColorFour}`}
                        data-value={(data.values.find(e => e.position === 'four') !== undefined) ? data.values.find(e => e.position === 'four').value : null}
                        onMouseEnter={e => hightLight4Numbers(data.number)}
                        onMouseLeave={e => props.cancelHighlight()}
                        onClick={props.wheelSpin === false ? e => add4Values('four') : null}
                    ></div>
                    : ''
            }

            {
                (data.number < 34)
                    ? <div data-value={(data.values.find(e => e.position === 'right') !== undefined) ? data.values.find(e => e.position === 'right').value : null}
                        onClick={props.wheelSpin === false ? e => add2HorizontalValues('right') : null}
                        className={`td-right ${(right !== undefined && resultValue === 0) ? 'active-cursor' : ''} ${selectColorHorizontal}`}
                        onMouseEnter={e => hightLight2NumbersVertically(data.number)}
                        onMouseLeave={e => props.cancelHighlight()}></div>
                    : ''
            }
            <div
                onClick={props.wheelSpin === false ? e => addValue('center') : null}
                className={`${(center !== undefined && resultValue === 0) ? 'oval active-cursor' : 'oval'} ${selectColorCenter}`}
                data-value={(data.values.find(e => e.position === 'center') !== undefined) ? data.values.find(e => e.position === 'center').value : null}
            >
                <span className={`oval table-number-value ${resultValue !== 0 && resultValue !== null ? resultValue.toString().includes('-') !== true ? 'win-color--blue minusResult' : 'win-color--blue' : ''}`}
                >{resultValue === 0 ? data.number : resultValue}</span>
            </div>
        </div>
    );
}
export default Number;